import { render, staticRenderFns } from "./applyResult.vue?vue&type=template&id=396211a5&scoped=true"
import script from "./applyResult.vue?vue&type=script&lang=js"
export * from "./applyResult.vue?vue&type=script&lang=js"
import style0 from "./applyResult.vue?vue&type=style&index=0&id=396211a5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396211a5",
  null
  
)

export default component.exports